import React from 'react';
import Icon from '../../../components/AppIcon';

const GuideCard = ({ guide }) => {
  const getDifficultyColor = (difficulty) => {
    switch (difficulty?.toLowerCase()) {
      case 'beginner':
        return 'text-green-500 bg-green-500/10';
      case 'intermediate':
        return 'text-yellow-500 bg-yellow-500/10';
      case 'advanced':
        return 'text-red-500 bg-red-500/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-all group">
      <div className="flex items-start justify-between mb-4">
        <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center group-hover:bg-primary/20 transition-colors">
          <Icon name={guide?.icon} size={24} color="var(--color-primary)" />
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${getDifficultyColor(guide?.difficulty)}`}>
          {guide?.difficulty}
        </span>
      </div>

      <h3 className="text-xl font-heading font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
        {guide?.title}
      </h3>
      <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
        {guide?.description}
      </p>

      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-1 text-sm text-muted-foreground">
            <Icon name="Clock" size={16} />
            <span>{guide?.duration}</span>
          </div>
          <div className="flex items-center space-x-1 text-sm text-muted-foreground">
            <Icon name="List" size={16} />
            <span>{guide?.steps} steps</span>
          </div>
        </div>

        <button className="flex items-center space-x-2 text-primary hover:text-primary/80 transition-colors">
          <span className="text-sm font-medium">Start Guide</span>
          <Icon name="ArrowRight" size={16} />
        </button>
      </div>
    </div>
  );
};

export default GuideCard;